export const BASE_URL = process.env.REACT_APP_API_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const GRAPHQL_DEV_CLIENT = `${process.env.REACT_APP_API_URL}/graphql`;
export const URL = process.env.REACT_APP_CONSOLE_APP_URL;
export const BASE_IMAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL
export const APP_URL = process.env.REACT_APP_URL
export const CVD_URL = process.env.REACT_APP_CVD
